import { useSessionSavedFilters } from "@/shared/hooks";
import type { FilterValue } from "@/ds";
import { SAVED_FILTERS_SCREEN } from "../embarcacoes.constants";

/** Filtros salvos de Embarcações, por usuário e separados das demais telas; aplicar reaproveita o `applyFilters` da lista. */
export function useEmbarcacoesFiltrosSalvos(applyFilters: (value: FilterValue) => void) {
  const { savedFilters, saveFilter, deleteFilter, applySavedFilter } =
    useSessionSavedFilters(SAVED_FILTERS_SCREEN);

  return {
    savedFilters,
    onSaveFilter: saveFilter,
    onDeleteSavedFilter: deleteFilter,
    onApplySavedFilter: (id: string) => applySavedFilter(id, applyFilters),
  };
}
